export const CHILIPIPER_URL = "chilipiperUrl";
export const CHILIPIPER_TIMEOUT = "chilipiperTimeout";
export const CHILIPIPER_LINK_TIMESTAMP = "chilipiperLinkTimestamp";
export const THANK_YOU_PAGE = "/contact-sales-thank-you";
export const CHILLI_PIPER_EVENT_ACTION_KEY = "action";
export const IFRANE_WIDTH = 740;
export const IFRAME_HEIGHT = 600;
export const CHILLI_PIPER_EVENTS = {
    BOOKING_CONFIRMED: "booking-confirmed",
    RESCHEDULED: "rescheduled",
    AVAILABILITY_LOADED: "availability-loaded"
};
